import * as nprogress from 'nprogress';
import 'nprogress/nprogress.css';

nprogress.configure({ trickleSpeed: 100, showSpinner: false });
